/**
 * §6.9 White-Label Admin Console — 8 admin capability cards.
 */

import React from 'react'
import {
  LayoutDashboard, UsersRound, Repeat, BellRing, PieChart, CreditCard,
  FileText, Bot, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { ADMIN_CAPS } from '../data'

const ICONS = { LayoutDashboard, UsersRound, Repeat, BellRing, PieChart, CreditCard, FileText, Bot, Sparkles }

export default function Admin() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Platform Administration</Eyebrow>
          <SectionHeading align="center"
            title={<>Run your platform{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">from one console.</span></>}
            subtitle="Eight capabilities cover the entire operational surface — users, revenue, notifications, analytics, billing, content and AI. No custom back-office to build."
          />
        </div>
        <FeatureGrid items={ADMIN_CAPS} icons={ICONS} cols={4} />
      </Container>
    </section>
  )
}
